module.exports = __webpack_public_path__ + "a419ea3bdd7a1c0764d5a83e36f4f3f6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CL.svg
// module id = NBoL
// module chunks = 0